var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('mc-receive',{attrs:{"mealCounts":_vm.mealCount},on:{"update:mealCounts":function($event){_vm.mealCount=$event},"update:meal-counts":function($event){_vm.mealCount=$event},"input-changed":_vm.inputChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }